import React from "react";
import "./PostMediaCard.css";
import { KEYS } from "../../../Config/Keys";
import VideoCard from "../Media/VideoCard";

const PostMediaCard = ({ files }) => {
  const renderMedia = (file, index) => {
    if (file?.file?.match(/\.(jpeg|jpg|gif|png|webp|svg|bmp|tiff|heif|avif|jfif)$/i)) {
      return (
        <img
          src={KEYS.API + "/" + file.file}
          alt={`file-${index}`}
          loading="lazy"
          className="media-img"
        />
      );
    } else {
      return (
        <VideoCard nodefault className="media-video" Timeline src={KEYS.API + "/" + file.file} />
      );
    }
  };

  return (
    <div className={`media-grid files-${files.length}`}>
      {files.slice(0, 5).map((file, index) => (
        <div key={index} className={`media-item files-${files.length}-${index + 1}`}>
          {renderMedia(file, index)}
        </div>
      ))}
    </div>
  );
};

export default PostMediaCard;
